import { render, staticRenderFns } from "./CreateEditTiposPesquisasModal.vue?vue&type=template&id=5d44d46b&"
import script from "./CreateEditTiposPesquisasModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditTiposPesquisasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports